import { UrlSegment, UrlSegmentGroup, Route } from '@angular/router';

export function RegexUrlMatcher(
    segments: UrlSegment[],
    segmentGroup: UrlSegmentGroup,
    route: Route,
    paramName: string,
    regex: RegExp) {

    const parts = [regex];
    const posParams: { [key: string]: UrlSegment } = {};
    const consumed: UrlSegment[] = [];

    let currentIndex = 0;

    for (const part of parts) {
        if (currentIndex >= segments.length) {
            return null;
        }
        const current = segments[currentIndex];

        if (!part.test(current.path)) {
            return null;
        }

        posParams[paramName] = current;
        consumed.push(current);
        currentIndex++;
    }

    if (route.pathMatch === 'full' &&
        (segmentGroup.hasChildren() || currentIndex < segments.length)) {
        return null;
    }

    return { consumed, posParams };
}
